module.exports = {
    english: "Englisch",
    slovak: "Slovakisch",
    deutsch: "Deutsch",
    log_in_using_local_account: "Melden Sie sich mit Ihrem lokalen konto an",
    user: "Benutzer",
    password: "Passwort",
    ws_icon_connected: "In Verbindung gebracht",
    ws_icon_not_connected: "Verbindungszeitüberschreitung"
}